import { on, reducer } from 'ts-action';
import * as undoActions from '../../undo/actions/undo.actions';
import * as ecgActions from '../actions/ecg.actions';
import { EcgState } from '../types/ecg-state';

declare module 'react-redux' {
  interface DefaultRootState {
    ecg: EcgState;
  }
}

const initialStateFactory = (): EcgState => ({
  analysisType: {
    event: false,
    holter: false,
    resting: true,
    rpm: false,
    mct: false,
  },
  recordType: 'resting',
  duration: 0,
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(ecgActions.loaded, (_state, { ecg }): EcgState => ecg),
  on(
    ecgActions.update,
    (state, { update }): EcgState => ({
      ...state,
      ...update,
    }),
  ),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { ecg } }): EcgState => {
      if (!ecg) {
        return state;
      }
      return { ...state, ...ecg };
    },
  ),
);
